import { apiRequest } from "../../apiCall";
import { outGoingPayload } from "../../types/outGoing/apiRequestType";

export const ouGoing = (params: outGoingPayload) =>  apiRequest('OutgoingCall.OutgoingCall', { },  `?customerLineId=${params.customerLineId}&firstSideNumber=${params.firstSideNumber}&secondSideNumber=${params.secondSideNumber}`, true)

